/**
 * Premium switch styles.
 *
 * These switch implementations previously shipped inside the free plugin's
 * bundle, where they were present for every user but only selectable with a
 * licence. They now live here and are registered into the free plugin's
 * switch registry at runtime.
 *
 * Copied verbatim from WP Dark Mode 5.3.11 so the rendered markup is identical.
 */

import Switch_4 from './switch-4';
import Switch_5 from './switch-5';
import Switch_6 from './switch-6';
import Switch_7 from './switch-7';
import Switch_8 from './switch-8';
import Switch_9 from './switch-9';
import Switch_10 from './switch-10';
import Switch_11 from './switch-11';
import Switch_12 from './switch-12';
import Switch_13 from './switch-13';
import Switch_14 from './switch-14';
import Switch_15 from './switch-15';
import Switch_16 from './switch-16';
import Switch_17 from './switch-17';
import Switch_18 from './switch-18';
import Switch_19 from './switch-19';
import Switch_20 from './switch-20';
import Switch_21 from './switch-21';
import Switch_22 from './switch-22';
import Switch_24 from './switch-24';

const ProSwitches = {
    Switch_4,
    Switch_5,
    Switch_6,
    Switch_7,
    Switch_8,
    Switch_9,
    Switch_10,
    Switch_11,
    Switch_12,
    Switch_13,
    Switch_14,
    Switch_15,
    Switch_16,
    Switch_17,
    Switch_18,
    Switch_19,
    Switch_20,
    Switch_21,
    Switch_22,
    Switch_24,
};

/**
 * Registers the premium switch styles into the free plugin's registry.
 */
export default function registerProSwitches() {
    if (typeof window === 'undefined' || !window.WPDarkModeSwitches) {
        return;
    }

    Object.assign(window.WPDarkModeSwitches, ProSwitches);
}
